class ActionScopeEnum {
  static INSTANCE = 'instance';
  static APPLICATION = 'application';
}

export const ActionScope = Object.freeze(ActionScopeEnum);
